import React from 'react';

import { IconProps } from './types';

export const PlusIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="22"
        viewBox="0 0 22 22"
        width="22"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path d="M11 5.73901V16.2608" stroke={color} strokeLinecap="round" />
        <path d="M16.2607 11L5.739 11" stroke={color} strokeLinecap="round" />
      </svg>
    );
  },
);
